<template>
  <div class="intent_wrapper">
    <div class="title">유닛 관리</div>
    <h4>{{ booktitle }}</h4>
    <div class="d-flex cont">
      <div class="left common">
        <b-overlay :show="loading" rounded="sm">
          <table class="table hover">
            <thead>
              <tr>
                <th width="20px">CD</th>
                <th>챕터명</th>
                <th></th>
              </tr>
            </thead>
            <draggable
              v-model="cpdChapters"
              tag="tbody"
              group="chapter"
              handle=".handle"
              ghost-class="ghost"
              @end="onEnd"
            >
              <tr
                :class="[
                  item.picked ? 'bg-primary' : '',
                  item.picked ? 'selected_row' : '',
                ]"
                :key="item.id"
                v-for="item in cpdChapters"
              >
                <td class="handle">{{ item.vorder }}</td>
                <td @click="pickrow(item)">
                  <b-badge pill :variant="item.cflag_variant">
                    {{ item.cflag_str }}
                  </b-badge>
                  {{ item.ctitle }}
                </td>
                <td class="buttons">
                  <b-button @click="modi(item)" variant="success" size="sm"
                    >변경</b-button
                  >
                  <b-button @click="remove(item)" variant="danger" size="sm"
                    >삭제</b-button
                  >
                </td>
              </tr>
            </draggable>
          </table>
        </b-overlay>
        <b-button
          @click="addChapter"
          class="float-right"
          variant="primary"
          size="sm"
          >챕터추가</b-button
        >
      </div>
      <div class="divider"></div>
      <div class="right common">
        <b-overlay :show="loading2" rounded="sm">
          <table class="table">
            <thead>
              <tr>
                <th width="20px">CD</th>
                <th>유닛명</th>
                <th></th>
              </tr>
            </thead>
            <draggable
              v-model="cpdUnits"
              tag="tbody"
              group="unit"
              handle=".handle"
              ghost-class="ghost"
              @end="onEndUnit"
            >
              <tr :key="item.id" v-for="item in cpdUnits">
                <td class="handle">{{ item.vorder }}</td>
                <td>{{ item.utitle }}</td>
                <td class="buttons">
                  <b-button @click="modiUnit(item)" variant="success" size="sm"
                    >변경</b-button
                  >
                  <b-button @click="removeUnit(item)" variant="danger" size="sm"
                    >삭제</b-button
                  >
                </td>
              </tr>
            </draggable>
            <tr v-if="units.length == 0">
              <td colspan="3" style="text-align: center">데이터가 없습니다.</td>
            </tr>
          </table>
        </b-overlay>
        <b-button
          v-if="hasChapter"
          @click="addUnit"
          class="float-right"
          variant="primary"
          size="sm"
          >유닛추가</b-button
        >
      </div>
      <svg
        style="position: absolute; opacity: 0.5; z-index: 1; display: none"
        width="calc(100vw - 90px)"
        height="calc(100vh - 250px)"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M480 105 C 480 150, 490 40, 500 70"
          stroke="#eb6e4c"
          stroke-width="3"
          fill="transparent"
        />
      </svg>
    </div>

    <XForm ref="mdlc" :formUnit="formUnit" />
    <CForm ref="mdlc" :formChapter="formChapter" />
  </div>
</template>

<script>
import XForm from "@/components/book/UnitForm";
import CForm from "@/components/book/ChapterForm";
import * as R from "ramda";
import draggable from "vuedraggable";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: { XForm, CForm, draggable },
  mounted() {
    this.updateBookID(this.$route.query.book_id);
    this.$store.dispatch("loadBookbyId", this.$route.query.book_id);

    let query = {
      flag: 0,
      subflag: null,
      book_id: this.$route.query.book_id,
    };
    this.getChapterList(query);

    this.updateOneChapter(null);
    this.updateUnits([]);
  },
  data() {
    return {
      loading: false,
      loading2: false,
      formChapter: {},
      formUnit: {},
    };
  },
  computed: {
    ...mapState("chapterStore", ["book_id", "chapters", "units", "chapter"]),

    booktitle() {
      return this.$store.state.bookform.title;
    },

    cpdChapters: {
      get() {
        return this.chapters;
      },
      set(value) {
        this.updateChapters(value);
      },
    },

    cpdUnits: {
      get() {
        return this.units;
      },
      set(value) {
        this.updateUnits(value);
      },
    },

    hasChapter() {
      return this.chapter != null && this.chapter.id != undefined
        ? true
        : false;
    },
  },

  methods: {
    ...mapMutations("chapterStore", [
      "updateBookID",
      "updateChapters",
      "updateChapterID",
      "updateOneChapter",
      "updateUnits",
    ]),
    ...mapActions("chapterStore", [
      "getChapterList",
      "orderChaperList",
      "orderUnitList",
      "removeChapter",
      "getUnitList",
    ]),
    addChapter() {
      this.formChapter = {};
      this.$nextTick(() => {
        this.$bvModal.show("myid2");
      });
    },

    addUnit() {
      this.$nextTick(() => {
        this.$bvModal.show("myid");
      });
    },
    modi(item) {
      this.formChapter = item;
      this.$nextTick(() => {
        this.$bvModal.show("myid2");
      });
    },
    modiUnit(item) {
      this.formUnit = item;
      console.log(this.formUnit);
      this.$nextTick(() => {
        this.$bvModal.show("myid");
      });
    },

    removeUnit(item) {
      this.formUnit = item;
      let $this = this;
      this.$bvModal
        .msgBoxConfirm("해당 유닛을 삭제하시겠습니까?", {
          title: "주의",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            $this.loading2 = true;
            $this.removeChapter($this.formUnit).then((resp) => {
              let query = {
                flag: 1,
                subflag: $this.chapter.id,
                book_id: $this.$route.query.book_id,
              };
              $this.getUnitList(query);
              $this.loading2 = false;
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    remove(item) {
      this.formChapter = item;

      let $this = this;

      this.$bvModal
        .msgBoxConfirm("해당 챕터를 삭제하시겠습니까?", {
          title: "주의",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            $this.loading = true;
            $this.removeChapter($this.formChapter).then((resp) => {
              let query = {
                flag: 0,
                subflag: null,
                book_id: $this.$route.query.book_id,
              };
              $this.getChapterList(query);
              $this.loading = false;
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    pickrow(item) {
      let _k = R.map((k) => {
        if (k.id === item.id) {
          k.picked = true;
        } else {
          k.picked = false;
        }

        return k;
      }, this.chapters);

      this.updateChapters(_k);
      this.updateOneChapter(item);
      let query = {};
      query.flag = 1;
      query.subflag = item.id;
      query.book_id = item.book_id;
      this.getUnitList(query);
    },
    async onEnd(evt) {
      let vorders = [];
      R.forEach((item) => {
        vorders.push(item.id);
      }, this.cpdChapters);
      this.loading = true;
      await this.orderChaperList(vorders);
      let query = {
        flag: 0,
        subflag: null,
        book_id: this.$route.query.book_id,
      };
      await this.getChapterList(query);
      this.loading = false;
    },

    async onEndUnit(evt) {
      let vorders = [];
      R.forEach((item) => {
        vorders.push(item.id);
      }, this.cpdUnits);
      this.loading2 = true;
      await this.orderUnitList(vorders);
      let query = {
        flag: 1,
        subflag: this.chapter.id,
        book_id: this.$route.query.book_id,
      };
      await this.getUnitList(query);
      this.loading2 = false;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.intent_wrapper {
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 3px 3px $gray400;
  min-height: 50vh;

  margin: 20px;
  padding: 20px;

  .handle {
    background: $gray100;
    cursor: pointer;
  }

  .ghost {
    background: $gray200;
    opacity: 0.5;
  }

  .buttons {
    button {
      margin-right: 10px;
    }
  }

  h4 {
    margin-top: 15px;
    padding-left: 10px;
    color: $color1;
  }
  .title {
    font-size: 1.2em;
    color: $gray50;
    background-color: $gray600;
    border-radius: 4px;
    padding-bottom: 6px;
  }
  .title::before {
    content: "";
    font-size: 1.5em;
    padding-left: 6px;
    color: $gray50;
  }
  .searchbox {
    margin: 10px 0 10px 0;
  }
  .buttons {
    text-align: right;
    margin: 4px 0 4px 0;
  }

  .nodata {
    text-align: center;
    color: $point1;
  }

  .divider {
    height: calc(100vh - 200px);
    width: 3px;
    background: $gray50;
  }

  .cont {
    height: 100%;
    margin-top: 15px;

    .common {
      width: 50%;
    }
    .left {
      margin-right: 15px;
    }
    .right {
      margin-left: 15px;
    }
  }
}
</style>